<script lang="ts">

  import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "$lib/components/ui/dialog"
  import { Label } from "$lib/components/ui/label"
  import { Separator } from "$lib/components/ui/separator"
  import type { Event } from "../_types"

  let {
    open,
    setOpen,
    select,
  }: {
    open: boolean
    setOpen: (open: boolean) => void
    select: Event
  } = $props()

</script>

<Dialog
  open={open}
  onOpenChange={setOpen}>
  <DialogContent
    class="w-sm"
    onOpenAutoFocus={(event) => event.preventDefault()}>
    <DialogHeader>
      <DialogTitle>Kegiatan</DialogTitle>
      <DialogDescription></DialogDescription>
    </DialogHeader>
    <div class="space-y-3">
      <div class="grid grid-cols-2 gap-3">
        <div>
          <Label>Nomor</Label>
          <div class="text-desc font-mono">{select.number || "-"}</div>
        </div>
        <div>
          <Label>Tanggal</Label>
          <div class="text-desc font-mono">{select.date.toDateFormat("dd/MM/yyyy")}</div>
        </div>
      </div>
      <div>
        <Label>Tipe</Label>
        <div class="text-desc">{select.type.name || "-"}</div>
      </div>
      <div>
        <Label>Sales</Label>
        <div class="text-desc">{select.sales_person.name || "-"}</div>
      </div>
      <Separator/>
      <div>
        <Label>Alamat</Label>
        <div class="text-desc">{select.address || "-"}</div>
      </div>
      <div>
        <Label>PIC</Label>
        <div class="text-desc">{select.pic_name || "-"}</div>
      </div>
      <div>
        <Label>Partisipan</Label>
        <div class="text-desc">{select.participant_count || "-"}</div>
      </div>
      <div>
        <Label>Keterangan</Label>
        <div class="text-desc">{select.description || "-"}</div>
      </div>
    </div>
  </DialogContent>
</Dialog>
